// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://devbmiapi.techprostudio.com',
  baseUrl: 'https://devbmifaculty.techprostudio.com',
  adminUrl: 'https://devbmiadmin.techprostudio.com',
  teacherUrl: 'https://devbmifaculty.techprostudio.com/',
  studentUrl: 'https://devbmistudent.techprostudio.com',
};



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/environments/environment.ts